import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { isBotmarkSuperAdmin } from '../../permissions/roleUtils';
import { useEditSAConfig, useSAConfig } from '../../hooks/useSAConfig';
import {
    Box,
    Button,
    TextField,
    Typography,
} from "@mui/material";
import Page from '../../components/Page';
import PermissionMatrix from './PermissionMatrix';

import { formatMoneyDisplayValue } from '../../utils/moneyFormat';

import "./adminConfig.css";

function AdminConfigMoneyRow({ label, value, onChange, onUpdate }) {
    return (
        <Box className="adminConfigMoneyRow">
            <Typography className="adminConfigMoneyLabel">{label}</Typography>
            <Typography className="adminConfigMoneySymbol" component="span">$</Typography>
            <TextField
                size="small"
                className="adminConfigMoneyInput"
                value={value ?? ''}
                onChange={(event) => onChange(event.target.value)}
                onBlur={() => onChange(formatMoneyDisplayValue(value))}
                inputProps={{ inputMode: 'decimal', 'aria-label': label }}
            />
            <Button variant="contained" size="small" onClick={onUpdate}>Update</Button>
        </Box>
    );
}

function AdminConfig(){
    const editSAConfig = useEditSAConfig();
    const { data: saConfigData = [] } = useSAConfig();
    const authenticated = useSelector((state) => state.UserReducer.isAuthenticated);

    const [defaultCompanyRate, setDefaultCompanyRate] = React.useState();
    const [publicAnn, setPublicAnn] = React.useState();
    const [internalAnn, setInternalAnn] = React.useState();
    const [baseServiceFee, setBaseServiceFee] = React.useState();

    function initValues(){
        for (let i = 0; i < saConfigData.length; i++){
            if(saConfigData[i].configName == 'Default Company Rate'){
                setDefaultCompanyRate(formatMoneyDisplayValue(saConfigData[i].configValue))
            } else if (saConfigData[i].configName == 'Public Announcements'){
                setPublicAnn(saConfigData[i].configValue)
            } else if (saConfigData[i].configName == 'Internal Announcements'){
                setInternalAnn(saConfigData[i].configValue)
            } else if (saConfigData[i].configName == 'Base Service Fee'){
                setBaseServiceFee(formatMoneyDisplayValue(saConfigData[i].configValue))
            }
        }
    }

    function updateCompanyRate(){
        const formatted = formatMoneyDisplayValue(defaultCompanyRate);
        setDefaultCompanyRate(formatted);
        editSAConfig.mutate({
            ConfigName: "Default Company Rate",
            ConfigValue: formatted,
        });
    }

    const publicAnnObj = {
        ConfigName: "Public Announcements",
        ConfigValue: `${publicAnn}`
    };

    function updatePublicAnn(){
        editSAConfig.mutate(publicAnnObj);
    }

    const internalAnnObj = {
        ConfigName: "Internal Announcements",
        ConfigValue: `${internalAnn}`
    };

    function updateInternalAnn(){
        editSAConfig.mutate(internalAnnObj);
    }

    function updateBaseServiceFee(){
        const formatted = formatMoneyDisplayValue(baseServiceFee);
        setBaseServiceFee(formatted);
        editSAConfig.mutate({
            ConfigName: "Base Service Fee",
            ConfigValue: formatted,
        });
    }
    
    useEffect(() => {
        initValues();
    },[saConfigData]);
    
    return(
        <Page title="Botmark Config">
        <Box>
            <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
                Botmark Admin Configurations
            </Typography>
            <Box className="adminConfigParent">
                <Box className="adminConfigRateRow">
                    <AdminConfigMoneyRow
                        label="Default Company Price Rate"
                        value={defaultCompanyRate}
                        onChange={setDefaultCompanyRate}
                        onUpdate={updateCompanyRate}
                    />
                    <AdminConfigMoneyRow
                        label="Base Service Fee"
                        value={baseServiceFee}
                        onChange={setBaseServiceFee}
                        onUpdate={updateBaseServiceFee}
                    />
                </Box>
                <Box className="adminConfigAnnRow">
                    <Box className="adminConfigAnnField">
                        <Typography className="adminConfigFieldLabel">Public Announcements</Typography>
                        <TextField
                            multiline
                            minRows={2}
                            maxRows={4}
                            fullWidth
                            size="small"
                            value={publicAnn ?? ''}
                            onChange={(event) => setPublicAnn(event.target.value)}
                        />
                        <Box className="adminConfigFieldActions">
                            <Button variant="contained" size="small" onClick={() => updatePublicAnn()}>Update</Button>
                        </Box>
                    </Box>
                    <Box className="adminConfigAnnField">
                        <Typography className="adminConfigFieldLabel">Internal Announcements</Typography>
                        <TextField
                            multiline
                            minRows={2}
                            maxRows={4}
                            fullWidth
                            size="small"
                            value={internalAnn ?? ''}
                            onChange={(event) => setInternalAnn(event.target.value)}
                        />
                        <Box className="adminConfigFieldActions">
                            <Button variant="contained" size="small" onClick={() => updateInternalAnn()}>Update</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {isBotmarkSuperAdmin(authenticated) && <PermissionMatrix />}
        </Box>
        </Page>
    )
}

export default AdminConfig;
